import { SkapaElement } from "@ingka/skapa-webc-element";
const styles = ':host{display:block;position:relative;width:inherit}slot{box-sizing:border-box;display:block;height:auto;padding-bottom:var(--skapa-aspect-ratio,75%);position:relative;width:100%}slot::slotted(*){color:#0000;height:100%;left:0;object-fit:cover;padding:0;position:absolute;top:0;width:100%}:host([ratio^="4:3"]),:host([ratio^=standard]){--skapa-aspect-ratio:75%}:host([ratio^="1:1"]),:host([ratio^=square]){--skapa-aspect-ratio:100%}:host([ratio^="16:9"]),:host([ratio^=wide]){--skapa-aspect-ratio:56.25%}:host([ratio^="3:4"]),:host([ratio^=portrait]){--skapa-aspect-ratio:133.3333333333%}:host([ratio^="6:7"]),:host([ratio^=semiportrait]){--skapa-aspect-ratio:116.6666666667%}:host([ratio^="9:16"]){--skapa-aspect-ratio:177.7777777778%}:host([ratio^="4:5"]){--skapa-aspect-ratio:125%}@media (min-width:37.5em){:host([ratio*=to-standard-from-md]){--skapa-aspect-ratio:75%}:host([ratio*=to-square-from-md]){--skapa-aspect-ratio:100%}:host([ratio*=to-wide-from-md]){--skapa-aspect-ratio:56.25%}:host([ratio*=to-portrait-from-md]){--skapa-aspect-ratio:133.3333333333%}:host([ratio*=to-semiportrait-from-md]){--skapa-aspect-ratio:116.6666666667%}}@media (min-width:56.25em){:host([ratio*=to-standard-from-lg]){--skapa-aspect-ratio:75%}:host([ratio*=to-square-from-lg]){--skapa-aspect-ratio:100%}:host([ratio*=to-wide-from-lg]){--skapa-aspect-ratio:56.25%}:host([ratio*=to-portrait-from-lg]){--skapa-aspect-ratio:133.3333333333%}:host([ratio*=to-semiportrait-from-lg]){--skapa-aspect-ratio:116.6666666667%}}';
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`<slot></slot
    ><style>
      ${styles}
    </style>`;
  return { main: template };
}
class AspectRatioBox extends SkapaElement {
  set ratio(val) {
    this.setAttribute("ratio", val);
  }
  get ratio() {
    return this.getAttribute("ratio");
  }
  constructor() {
    super();
    this.gatherProperties(["ratio"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const templates = this.getTemplates(generateTemplate);
    shadow.append(templates.main.content.cloneNode(true));
  }
}
AspectRatioBox.skapaTagName = "aspect-ratio";
AspectRatioBox.skapaDependencies = [];
var AspectRatioBox_default = AspectRatioBox;
export {
  AspectRatioBox,
  AspectRatioBox_default as default
};
